import { SET_USER_LOCATION } from './constants';

const initialState = {
  location: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_LOCATION:
      return {
        ...state,
        location: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;